var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0999 3.95C19.7999 3.65 19.4999 3.5 19.0999 3.5H12.8999V11.15H20.5499V4.95C20.5499 4.55 20.3999 4.2 20.0999 3.95ZM19.3999 10.05H13.9999V4.65H19.0999C19.1999 4.65 19.2499 4.65 19.2999 4.75C19.3499 4.8 19.3999 4.9 19.3999 4.95V10.05Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8999 20.5H19.0999C19.4999 20.5 19.8499 20.35 20.0999 20.05C20.3499 19.75 20.5499 19.45 20.5499 19.05V12.8H12.8999V20.5ZM13.9999 13.95H19.3999V19.05C19.3999 19.15 19.3999 19.2 19.2999 19.25C19.2499 19.3 19.1499 19.35 19.0999 19.35H13.9999V13.9V13.95Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4502 19.05C3.4502 19.45 3.6002 19.8 3.9002 20.05C4.2002 20.35 4.5002 20.5 4.9002 20.5H11.1002V12.8H3.4502V19.05ZM4.6002 13.95H10.0002V19.4H4.9002C4.8002 19.4 4.7502 19.4 4.7002 19.3C4.6502 19.2 4.6002 19.15 4.6002 19.1V14V13.95Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9002 3.95C3.6002 4.25 3.4502 4.55 3.4502 4.95V11.15H11.1002V3.5H4.9002C4.5002 3.5 4.1502 3.65 3.9002 3.95ZM10.0002 10.05H4.6002V4.95C4.6002 4.85 4.6002 4.8 4.7002 4.75C4.8002 4.7 4.8502 4.65 4.9002 4.65H10.0002V10.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollages);
export default __webpack_public_path__ + "static/media/collages.413c211a3095d642be58a8c5fbacb869.svg";
export { ForwardRef as ReactComponent };